(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["creepseat-social-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(section) {
    if (section.dataset.cspInitialized) return;
    section.dataset.cspInitialized = '1';

    var track   = section.querySelector('[data-csp-track]');
    var cards   = section.querySelectorAll('[data-csp-card]');
    var prevBtn = section.querySelector('[data-csp-prev]');
    var nextBtn = section.querySelector('[data-csp-next]');
    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var currentIndex = 0;
    var scrollTimer;
    var resizeTimer;

    function getVisible() {
      if (window.innerWidth >= 990) return 3;
      if (window.innerWidth >= 750) return 2;
      return 1;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function updateButtons() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function scrollToIndex() {
      var card = cards[currentIndex];
      if (!card) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - track.offsetLeft) - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      }
      currentIndex = Math.min(closest, getMaxIndex());
      updateButtons();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; scrollToIndex(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) { currentIndex++; scrollToIndex(); }
    });

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        scrollToIndex();
      }, 100);
    });

    scrollToIndex();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-csp-section]').forEach(initCarousel);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('[data-csp-section]');
    if (!sectionEl) return;
    sectionEl.removeAttribute('data-csp-initialized');
    initCarousel(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dog-pouch-hoodie-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initDphFaq(section) {
    var buttons = section.querySelectorAll('.dph-faq-q');
    var list = section.querySelector('.dph-faq-list');
    if (!buttons.length || !list) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.dph-faq-item');
        if (!item) return;
        var wasOpen = item.classList.contains('is-open');
        list.querySelectorAll('.dph-faq-item.is-open').forEach(function (openItem) {
          openItem.classList.remove('is-open');
          var openBtn = openItem.querySelector('.dph-faq-q');
          if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.dog-pouch-hoodie-faq').forEach(initDphFaq);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (evt) {
    var el = evt.target.querySelector('.dog-pouch-hoodie-faq');
    if (el) initDphFaq(el);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dog-pouch-hoodie-reaction-quote"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initDphQuoteCarousel(section) {
    if (section.dataset.gcQuoteInitialized) return;
    section.dataset.gcQuoteInitialized = '1';

    var track   = section.querySelector('[data-dph-quote-track]');
    var cards   = section.querySelectorAll('[data-dph-quote-card]');
    var prevBtn = section.querySelector('[data-dph-quote-prev]');
    var nextBtn = section.querySelector('[data-dph-quote-next]');
    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var currentIndex = 0;
    var scrollTimer;
    var resizeTimer;

    function getVisible() {
      return window.innerWidth >= 750 ? 2 : 1;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function updateButtons() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function scrollToIndex() {
      var card = cards[currentIndex];
      if (!card) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - track.offsetLeft) - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      }
      currentIndex = Math.min(closest, getMaxIndex());
      updateButtons();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; scrollToIndex(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) { currentIndex++; scrollToIndex(); }
    });

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        scrollToIndex();
      }, 100);
    });

    scrollToIndex();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-dph-quote-section]').forEach(initDphQuoteCarousel);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('[data-dph-quote-section]');
    if (!sectionEl) return;
    sectionEl.removeAttribute('data-dph-quote-initialized');
    initDphQuoteCarousel(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dog-pouch-hoodie-social-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initDphCarousel(section) {
    if (section.dataset.dphInitialized) return;
    section.dataset.dphInitialized = '1';

    var track   = section.querySelector('[data-dph-track]');
    var cards   = section.querySelectorAll('[data-dph-card]');
    var prevBtn = section.querySelector('[data-dph-prev]');
    var nextBtn = section.querySelector('[data-dph-next]');
    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var currentIndex = 0;
    var scrollTimer;
    var resizeTimer;

    function getVisible() {
      if (window.innerWidth >= 990) return 3;
      if (window.innerWidth >= 750) return 2;
      return 1;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function updateButtons() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function scrollToIndex() {
      var card = cards[currentIndex];
      if (!card) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - track.offsetLeft) - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      }
      currentIndex = Math.min(closest, getMaxIndex());
      updateButtons();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; scrollToIndex(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) { currentIndex++; scrollToIndex(); }
    });

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        scrollToIndex();
      }, 100);
    });

    scrollToIndex();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-dph-section]').forEach(initDphCarousel);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('[data-dph-section]');
    if (!sectionEl) return;
    sectionEl.removeAttribute('data-dph-initialized');
    initDphCarousel(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["duck-baby-onesie-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initDboFaq(section) {
    section.querySelectorAll('.dbo-faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.dbo-faq-item');
        var isOpen = item.classList.contains('is-open');

        section.querySelectorAll('.dbo-faq-item.is-open').forEach(function (openItem) {
          openItem.classList.remove('is-open');
          openItem.querySelector('.dbo-faq-q').setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  document.querySelectorAll('.duck-baby-onesie-faq').forEach(initDboFaq);

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('.duck-baby-onesie-faq');
    if (sectionEl) initDboFaq(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["duck-baby-onesie-reaction-quote"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initDboQuoteCarousel(section) {
    if (section.dataset.dboQuoteInitialized) return;
    section.dataset.dboQuoteInitialized = '1';

    var track   = section.querySelector('[data-dbo-quote-track]');
    var cards   = section.querySelectorAll('[data-dbo-quote-card]');
    var prevBtn = section.querySelector('[data-dbo-quote-prev]');
    var nextBtn = section.querySelector('[data-dbo-quote-next]');
    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var currentIndex = 0;
    var scrollTimer;
    var resizeTimer;

    function getVisible() {
      return window.innerWidth >= 750 ? 2 : 1;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function updateButtons() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function scrollToIndex() {
      var card = cards[currentIndex];
      if (!card) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - track.offsetLeft) - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      }
      currentIndex = Math.min(closest, getMaxIndex());
      updateButtons();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; scrollToIndex(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) { currentIndex++; scrollToIndex(); }
    });

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        scrollToIndex();
      }, 100);
    });

    scrollToIndex();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-dbo-quote-section]').forEach(initDboQuoteCarousel);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('[data-dbo-quote-section]');
    if (!sectionEl) return;
    sectionEl.removeAttribute('data-dbo-quote-initialized');
    initDboQuoteCarousel(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["duck-baby-onesie-social-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initDboCarousel(section) {
    if (section.dataset.dboInitialized) return;
    section.dataset.dboInitialized = '1';

    var track   = section.querySelector('[data-dbo-track]');
    var cards   = section.querySelectorAll('[data-dbo-card]');
    var prevBtn = section.querySelector('[data-dbo-prev]');
    var nextBtn = section.querySelector('[data-dbo-next]');
    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var currentIndex = 0;
    var scrollTimer;
    var resizeTimer;

    function getVisible() {
      if (window.innerWidth >= 990) return 3;
      if (window.innerWidth >= 750) return 2;
      return 1;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function updateButtons() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function scrollToIndex() {
      var card = cards[currentIndex];
      if (!card) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - track.offsetLeft) - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      }
      currentIndex = Math.min(closest, getMaxIndex());
      updateButtons();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; scrollToIndex(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) { currentIndex++; scrollToIndex(); }
    });

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        scrollToIndex();
      }, 100);
    });

    scrollToIndex();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-dbo-section]').forEach(initDboCarousel);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('[data-dbo-section]');
    if (!sectionEl) return;
    sectionEl.removeAttribute('data-dbo-initialized');
    initDboCarousel(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glostrip-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGsFaq(section) {
    var buttons = section.querySelectorAll('.gs-faq-q');
    var list = section.querySelector('.gs-faq-list');
    if (!buttons.length || !list) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.gs-faq-item');
        if (!item) return;
        var wasOpen = item.classList.contains('is-open');
        list.querySelectorAll('.gs-faq-item.is-open').forEach(function (openItem) {
          openItem.classList.remove('is-open');
          var openBtn = openItem.querySelector('.gs-faq-q');
          if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.glostrip-faq').forEach(initGsFaq);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (evt) {
    var el = evt.target.querySelector('.glostrip-faq');
    if (el) initGsFaq(el);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glostrip-reaction-quote"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGsQuoteCarousel(section) {
    if (section.dataset.gcQuoteInitialized) return;
    section.dataset.gcQuoteInitialized = '1';

    var track   = section.querySelector('[data-gs-quote-track]');
    var cards   = section.querySelectorAll('[data-gs-quote-card]');
    var prevBtn = section.querySelector('[data-gs-quote-prev]');
    var nextBtn = section.querySelector('[data-gs-quote-next]');
    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var currentIndex = 0;
    var scrollTimer;
    var resizeTimer;

    function getVisible() {
      return window.innerWidth >= 750 ? 2 : 1;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function updateButtons() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function scrollToIndex() {
      var card = cards[currentIndex];
      if (!card) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - track.offsetLeft) - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      }
      currentIndex = Math.min(closest, getMaxIndex());
      updateButtons();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; scrollToIndex(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) { currentIndex++; scrollToIndex(); }
    });

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        scrollToIndex();
      }, 100);
    });

    scrollToIndex();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-gs-quote-section]').forEach(initGsQuoteCarousel);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('[data-gs-quote-section]');
    if (!sectionEl) return;
    sectionEl.removeAttribute('data-gs-quote-initialized');
    initGsQuoteCarousel(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glostrip-social-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGsCarousel(section) {
    if (section.dataset.gsInitialized) return;
    section.dataset.gsInitialized = '1';

    var track   = section.querySelector('[data-gs-track]');
    var cards   = section.querySelectorAll('[data-gs-card]');
    var prevBtn = section.querySelector('[data-gs-prev]');
    var nextBtn = section.querySelector('[data-gs-next]');
    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var currentIndex = 0;
    var scrollTimer;
    var resizeTimer;

    function getVisible() {
      if (window.innerWidth >= 990) return 3;
      if (window.innerWidth >= 750) return 2;
      return 1;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function updateButtons() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function scrollToIndex() {
      var card = cards[currentIndex];
      if (!card) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - track.offsetLeft) - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      }
      currentIndex = Math.min(closest, getMaxIndex());
      updateButtons();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; scrollToIndex(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) { currentIndex++; scrollToIndex(); }
    });

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        scrollToIndex();
      }, 100);
    });

    scrollToIndex();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-gs-section]').forEach(initGsCarousel);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('[data-gs-section]');
    if (!sectionEl) return;
    sectionEl.removeAttribute('data-gs-initialized');
    initGsCarousel(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goggle-cap-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGcFaq(section) {
    var buttons = section.querySelectorAll('.gc-faq-q');
    var list = section.querySelector('.gc-faq-list');
    if (!buttons.length || !list) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.gc-faq-item');
        if (!item) return;
        var wasOpen = item.classList.contains('is-open');
        list.querySelectorAll('.gc-faq-item.is-open').forEach(function (openItem) {
          openItem.classList.remove('is-open');
          var openBtn = openItem.querySelector('.gc-faq-q');
          if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.goggle-cap-faq').forEach(initGcFaq);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (evt) {
    var el = evt.target.querySelector('.goggle-cap-faq');
    if (el) initGcFaq(el);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goggle-cap-reaction-quote"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGcQuoteCarousel(section) {
    if (section.dataset.gcQuoteInitialized) return;
    section.dataset.gcQuoteInitialized = '1';

    var track   = section.querySelector('[data-gc-quote-track]');
    var cards   = section.querySelectorAll('[data-gc-quote-card]');
    var prevBtn = section.querySelector('[data-gc-quote-prev]');
    var nextBtn = section.querySelector('[data-gc-quote-next]');
    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var currentIndex = 0;
    var scrollTimer;
    var resizeTimer;

    function getVisible() {
      return window.innerWidth >= 750 ? 2 : 1;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function updateButtons() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function scrollToIndex() {
      var card = cards[currentIndex];
      if (!card) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - track.offsetLeft) - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      }
      currentIndex = Math.min(closest, getMaxIndex());
      updateButtons();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; scrollToIndex(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) { currentIndex++; scrollToIndex(); }
    });

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        scrollToIndex();
      }, 100);
    });

    scrollToIndex();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-gc-quote-section]').forEach(initGcQuoteCarousel);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('[data-gc-quote-section]');
    if (!sectionEl) return;
    sectionEl.removeAttribute('data-gc-quote-initialized');
    initGcQuoteCarousel(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goggle-cap-social-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGcCarousel(section) {
    if (section.dataset.gcInitialized) return;
    section.dataset.gcInitialized = '1';

    var track   = section.querySelector('[data-gc-track]');
    var cards   = section.querySelectorAll('[data-gc-card]');
    var prevBtn = section.querySelector('[data-gc-prev]');
    var nextBtn = section.querySelector('[data-gc-next]');
    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var currentIndex = 0;
    var scrollTimer;
    var resizeTimer;

    function getVisible() {
      if (window.innerWidth >= 990) return 3;
      if (window.innerWidth >= 750) return 2;
      return 1;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function updateButtons() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function scrollToIndex() {
      var card = cards[currentIndex];
      if (!card) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - track.offsetLeft) - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      }
      currentIndex = Math.min(closest, getMaxIndex());
      updateButtons();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; scrollToIndex(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) { currentIndex++; scrollToIndex(); }
    });

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        scrollToIndex();
      }, 100);
    });

    scrollToIndex();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-gc-section]').forEach(initGcCarousel);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('[data-gc-section]');
    if (!sectionEl) return;
    sectionEl.removeAttribute('data-gc-initialized');
    initGcCarousel(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nail-working-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGsFaq(section) {
    var buttons = section.querySelectorAll('.gs-faq-q');
    var list = section.querySelector('.gs-faq-list');
    if (!buttons.length || !list) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.gs-faq-item');
        if (!item) return;
        var wasOpen = item.classList.contains('is-open');
        list.querySelectorAll('.gs-faq-item.is-open').forEach(function (openItem) {
          openItem.classList.remove('is-open');
          var openBtn = openItem.querySelector('.gs-faq-q');
          if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.glostrip-faq').forEach(initGsFaq);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (evt) {
    var el = evt.target.querySelector('.glostrip-faq');
    if (el) initGsFaq(el);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oddpop-support-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var form = root.querySelector('form');
    var fieldset = root.querySelector('[data-pill-required="true"]');
    if (!form || !fieldset) return;
    var errorMsg = fieldset.querySelector('[data-pill-error]');
    var radios = fieldset.querySelectorAll('input[type="radio"]');

    function isChecked() {
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].checked) return true;
      }
      return false;
    }
    function clearError() {
      fieldset.classList.remove('field-wrapper--error');
      if (errorMsg) errorMsg.classList.add('hidden');
    }
    function showError() {
      fieldset.classList.add('field-wrapper--error');
      if (errorMsg) errorMsg.classList.remove('hidden');
    }
    for (var j = 0; j < radios.length; j++) {
      radios[j].addEventListener('change', clearError);
    }
    form.addEventListener('submit', function (event) {
      if (!isChecked()) {
        event.preventDefault();
        showError();
        fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  document.querySelectorAll('.oddpop-support').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["old-man-face-balaclava-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initOmbFaq(section) {
    var buttons = section.querySelectorAll('.omb-faq-q');
    var list = section.querySelector('.omb-faq-list');
    if (!buttons.length || !list) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.omb-faq-item');
        if (!item) return;
        var wasOpen = item.classList.contains('is-open');
        list.querySelectorAll('.omb-faq-item.is-open').forEach(function (openItem) {
          openItem.classList.remove('is-open');
          var openBtn = openItem.querySelector('.omb-faq-q');
          if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.old-man-face-balaclava-faq').forEach(initOmbFaq);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (evt) {
    var el = evt.target.querySelector('.old-man-face-balaclava-faq');
    if (el) initOmbFaq(el);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["old-man-face-balaclava-reaction-quote"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initOmbQuoteCarousel(section) {
    if (section.dataset.gcQuoteInitialized) return;
    section.dataset.gcQuoteInitialized = '1';

    var track   = section.querySelector('[data-omb-quote-track]');
    var cards   = section.querySelectorAll('[data-omb-quote-card]');
    var prevBtn = section.querySelector('[data-omb-quote-prev]');
    var nextBtn = section.querySelector('[data-omb-quote-next]');
    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var currentIndex = 0;
    var scrollTimer;
    var resizeTimer;

    function getVisible() {
      return window.innerWidth >= 750 ? 2 : 1;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function updateButtons() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function scrollToIndex() {
      var card = cards[currentIndex];
      if (!card) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - track.offsetLeft) - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      }
      currentIndex = Math.min(closest, getMaxIndex());
      updateButtons();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; scrollToIndex(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) { currentIndex++; scrollToIndex(); }
    });

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        scrollToIndex();
      }, 100);
    });

    scrollToIndex();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-omb-quote-section]').forEach(initOmbQuoteCarousel);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('[data-omb-quote-section]');
    if (!sectionEl) return;
    sectionEl.removeAttribute('data-omb-quote-initialized');
    initOmbQuoteCarousel(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["old-man-face-balaclava-social-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initOmbCarousel(section) {
    if (section.dataset.ombInitialized) return;
    section.dataset.ombInitialized = '1';

    var track   = section.querySelector('[data-omb-track]');
    var cards   = section.querySelectorAll('[data-omb-card]');
    var prevBtn = section.querySelector('[data-omb-prev]');
    var nextBtn = section.querySelector('[data-omb-next]');
    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var currentIndex = 0;
    var scrollTimer;
    var resizeTimer;

    function getVisible() {
      if (window.innerWidth >= 990) return 3;
      if (window.innerWidth >= 750) return 2;
      return 1;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function updateButtons() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function scrollToIndex() {
      var card = cards[currentIndex];
      if (!card) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - track.offsetLeft) - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      }
      currentIndex = Math.min(closest, getMaxIndex());
      updateButtons();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; scrollToIndex(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) { currentIndex++; scrollToIndex(); }
    });

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        scrollToIndex();
      }, 100);
    });

    scrollToIndex();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-omb-section]').forEach(initOmbCarousel);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('[data-omb-section]');
    if (!sectionEl) return;
    sectionEl.removeAttribute('data-omb-initialized');
    initOmbCarousel(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-bucket-hat-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFaq(section) {
    section.querySelectorAll('.pbh-faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.pbh-faq-item');
        var isOpen = item.classList.contains('is-open');

        section.querySelectorAll('.pbh-faq-item.is-open').forEach(function (openItem) {
          openItem.classList.remove('is-open');
          openItem.querySelector('.pbh-faq-q').setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  document.querySelectorAll('.pet-bucket-hat-faq').forEach(initFaq);

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('.pet-bucket-hat-faq');
    if (sectionEl) initFaq(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-bucket-hat-reaction-quote"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initQuoteCarousel(section) {
    if (section.dataset.pbhQuoteInitialized) return;
    section.dataset.pbhQuoteInitialized = '1';

    var track   = section.querySelector('[data-pbh-quote-track]');
    var cards   = section.querySelectorAll('[data-pbh-quote-card]');
    var prevBtn = section.querySelector('[data-pbh-quote-prev]');
    var nextBtn = section.querySelector('[data-pbh-quote-next]');
    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var currentIndex = 0;
    var scrollTimer;
    var resizeTimer;

    function getVisible() {
      return window.innerWidth >= 750 ? 2 : 1;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function updateButtons() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function scrollToIndex() {
      var card = cards[currentIndex];
      if (!card) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - track.offsetLeft) - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      }
      currentIndex = Math.min(closest, getMaxIndex());
      updateButtons();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; scrollToIndex(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) { currentIndex++; scrollToIndex(); }
    });

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        scrollToIndex();
      }, 100);
    });

    scrollToIndex();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-pbh-quote-section]').forEach(initQuoteCarousel);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('[data-pbh-quote-section]');
    if (!sectionEl) return;
    sectionEl.removeAttribute('data-pbh-quote-initialized');
    initQuoteCarousel(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-bucket-hat-size-guide"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Recommendation logic ─────────────────────────── */
  function recommend(head) {
    var adj = head + 1.0;
    if (adj <= 10.5) return { type: 'normal', size: 'S' };
    if (adj <= 13.6) return { type: 'normal', size: 'M' };
    if (head <= 16.3) return { type: 'normal', size: 'L' };
    if (head <= 17.3) return { type: 'snug', size: 'L' };
    return { type: 'none' };
  }

  /* ── Build result HTML ────────────────────────────── */
  function buildResult(rec) {
    if (rec.type === 'normal') {
      return (
        '<div class="pbh-result pbh-result--match">' +
        '<p class="pbh-result__label">BEST PICK</p>' +
        '<p class="pbh-result__size">' + rec.size + '</p>' +
        '<p class="pbh-result__body">Based on the head measurement you entered, ' + rec.size + ' is our recommended starting size.</p>' +
        '<p class="pbh-result__size-up">Not sure? Go up a size — the chin cord can help secure a slightly roomy hat.</p>' +
        '<button type="button" class="pbh-result__choose" data-pbh-close-result>GOT IT</button>' +
        '</div>'
      );
    }

    if (rec.type === 'snug') {
      return (
        '<div class="pbh-result pbh-result--snug">' +
        '<p class="pbh-result__label">L MAY FIT SNUG</p>' +
        '<p class="pbh-result__size">L</p>' +
        '<p class="pbh-result__body">L is our largest size. Your pet’s measurement is close to the hat’s estimated inside measurement, so the fit may be snug.</p>' +
        '<button type="button" class="pbh-result__choose" data-pbh-close-result>GOT IT</button>' +
        '</div>'
      );
    }

    return (
      '<div class="pbh-result pbh-result--none">' +
      '<p class="pbh-result__label">WE DON’T HAVE A CONFIDENT FIT</p>' +
      '<p class="pbh-result__body">Your pet’s head measurement is larger than the estimated inside measurement of our largest size.</p>' +
      '<button type="button" class="pbh-result__choose pbh-result__choose--neutral" data-pbh-close-result>GOT IT</button>' +
      '</div>'
    );
  }

  /* ── Input validation ─────────────────────────────── */
  function validate(raw) {
    if (raw === '' || raw == null) {
      return { ok: false, msg: 'Please enter your pet’s head size in inches.' };
    }
    var val = parseFloat(raw);
    if (isNaN(val)) {
      return { ok: false, msg: 'Please enter a number. Example: 11.5' };
    }
    if (val <= 0) {
      return { ok: false, msg: 'Please enter a positive measurement.' };
    }
    if (val > 50) {
      return { ok: false, msg: 'That measurement seems too large. Please check and try again.' };
    }
    return { ok: true, val: val };
  }

  /* ── Modal state ──────────────────────────────────── */
  var currentModal = null;
  var lastTrigger = null;

  function openModal(modal) {
    modal.removeAttribute('hidden');
    modal.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    currentModal = modal;
    var closeBtn = modal.querySelector('[data-pbh-close]');
    if (closeBtn) { setTimeout(function () { closeBtn.focus(); }, 50); }
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
    currentModal = null;
    if (lastTrigger) { lastTrigger.focus(); }
  }

  /* ── Focus trap ───────────────────────────────────── */
  function trapFocus(modal, e) {
    var sel = 'button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])';
    var nodes = Array.prototype.slice.call(modal.querySelectorAll(sel));
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }

  /* ── Run calculator ───────────────────────────────── */
  function runCalc(inputEl, resultEl) {
    var v = validate(inputEl.value.trim());
    if (!v.ok) {
      resultEl.innerHTML = '<p class="pbh-result__error">' + v.msg + '</p>';
      resultEl.removeAttribute('hidden');
      return;
    }
    var rec = recommend(v.val);
    resultEl.innerHTML = buildResult(rec);
    resultEl.removeAttribute('hidden');

    resultEl.querySelectorAll('[data-pbh-close-result]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeModal(currentModal);
      });
    });
  }

  /* ── Bind trigger buttons ─────────────────────────── */
  function bindTriggers(modal) {
    document.querySelectorAll('[data-pbh-size-trigger]').forEach(function (btn) {
      if (btn._pbhTriggerBound) return;
      btn._pbhTriggerBound = true;
      btn.addEventListener('click', function () {
        lastTrigger = btn;
        openModal(modal);
      });
    });
  }

  /* ── Init one guide section ───────────────────────── */
  function initGuide(section) {
    if (section._pbhInit) return;
    section._pbhInit = true;

    var modal = section.querySelector('.pbh-size-modal');
    if (!modal) return;

    /* Move modal to <body> for z-index + scroll-lock correctness */
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    /* Backdrop */
    var backdrop = modal.querySelector('[data-pbh-backdrop]');
    if (backdrop) {
      backdrop.addEventListener('click', function () { closeModal(modal); });
    }

    /* Close button */
    var closeBtn = modal.querySelector('[data-pbh-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () { closeModal(modal); });
    }

    /* Modal keyboard: Escape + Tab trap */
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeModal(modal); }
      if (e.key === 'Tab') { trapFocus(modal, e); }
    });

    /* Calculator */
    var inputEl  = modal.querySelector('[data-pbh-input]');
    var submitEl = modal.querySelector('[data-pbh-submit]');
    var resultEl = modal.querySelector('[data-pbh-result]');

    if (inputEl && submitEl && resultEl) {
      submitEl.addEventListener('click', function () { runCalc(inputEl, resultEl); });
      inputEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); runCalc(inputEl, resultEl); }
      });
    }

    bindTriggers(modal);
  }

  /* ── Global Escape ────────────────────────────────── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && currentModal) { closeModal(currentModal); }
  });

  /* ── Init on load ─────────────────────────────────── */
  function initAll() {
    document.querySelectorAll('.pbh-size-guide-section').forEach(initGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* ── Theme editor section reload ──────────────────── */
  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;

    var guideSec = container.querySelector('.pbh-size-guide-section');
    if (guideSec) {
      guideSec._pbhInit = false;
      initGuide(guideSec);
      return;
    }

    var existingModal = document.querySelector('.pbh-size-modal');
    if (existingModal) {
      document.querySelectorAll('[data-pbh-size-trigger]').forEach(function (btn) {
        btn._pbhTriggerBound = false;
      });
      bindTriggers(existingModal);
    }
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-bucket-hat-social-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(section) {
    if (section.dataset.pbhInitialized) return;
    section.dataset.pbhInitialized = '1';

    var track   = section.querySelector('[data-pbh-track]');
    var cards   = section.querySelectorAll('[data-pbh-card]');
    var prevBtn = section.querySelector('[data-pbh-prev]');
    var nextBtn = section.querySelector('[data-pbh-next]');
    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var currentIndex = 0;
    var scrollTimer;
    var resizeTimer;

    function getVisible() {
      if (window.innerWidth >= 990) return 3;
      if (window.innerWidth >= 750) return 2;
      return 1;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function updateButtons() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function scrollToIndex() {
      var card = cards[currentIndex];
      if (!card) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - track.offsetLeft) - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      }
      currentIndex = Math.min(closest, getMaxIndex());
      updateButtons();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; scrollToIndex(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) { currentIndex++; scrollToIndex(); }
    });

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        scrollToIndex();
      }, 100);
    });

    scrollToIndex();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-pbh-section]').forEach(initCarousel);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('[data-pbh-section]');
    if (!sectionEl) return;
    sectionEl.removeAttribute('data-pbh-initialized');
    initCarousel(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soft-pet-chest-carrier-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSpccFaq(section) {
    var buttons = section.querySelectorAll('.spcc-faq-q');
    var list = section.querySelector('.spcc-faq-list');
    if (!buttons.length || !list) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.spcc-faq-item');
        if (!item) return;
        var wasOpen = item.classList.contains('is-open');
        list.querySelectorAll('.spcc-faq-item.is-open').forEach(function (openItem) {
          openItem.classList.remove('is-open');
          var openBtn = openItem.querySelector('.spcc-faq-q');
          if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.soft-pet-chest-carrier-faq').forEach(initSpccFaq);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (evt) {
    var el = evt.target.querySelector('.soft-pet-chest-carrier-faq');
    if (el) initSpccFaq(el);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soft-pet-chest-carrier-reaction-quote"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSpccQuoteCarousel(section) {
    if (section.dataset.gcQuoteInitialized) return;
    section.dataset.gcQuoteInitialized = '1';

    var track   = section.querySelector('[data-spcc-quote-track]');
    var cards   = section.querySelectorAll('[data-spcc-quote-card]');
    var prevBtn = section.querySelector('[data-spcc-quote-prev]');
    var nextBtn = section.querySelector('[data-spcc-quote-next]');
    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var currentIndex = 0;
    var scrollTimer;
    var resizeTimer;

    function getVisible() {
      return window.innerWidth >= 750 ? 2 : 1;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function updateButtons() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function scrollToIndex() {
      var card = cards[currentIndex];
      if (!card) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - track.offsetLeft) - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      }
      currentIndex = Math.min(closest, getMaxIndex());
      updateButtons();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; scrollToIndex(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) { currentIndex++; scrollToIndex(); }
    });

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        scrollToIndex();
      }, 100);
    });

    scrollToIndex();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-spcc-quote-section]').forEach(initSpccQuoteCarousel);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('[data-spcc-quote-section]');
    if (!sectionEl) return;
    sectionEl.removeAttribute('data-spcc-quote-initialized');
    initSpccQuoteCarousel(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soft-pet-chest-carrier-social-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSpccCarousel(section) {
    if (section.dataset.spccInitialized) return;
    section.dataset.spccInitialized = '1';

    var track   = section.querySelector('[data-spcc-track]');
    var cards   = section.querySelectorAll('[data-spcc-card]');
    var prevBtn = section.querySelector('[data-spcc-prev]');
    var nextBtn = section.querySelector('[data-spcc-next]');
    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var currentIndex = 0;
    var scrollTimer;
    var resizeTimer;

    function getVisible() {
      if (window.innerWidth >= 990) return 3;
      if (window.innerWidth >= 750) return 2;
      return 1;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function updateButtons() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function scrollToIndex() {
      var card = cards[currentIndex];
      if (!card) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - track.offsetLeft) - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      }
      currentIndex = Math.min(closest, getMaxIndex());
      updateButtons();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; scrollToIndex(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) { currentIndex++; scrollToIndex(); }
    });

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        scrollToIndex();
      }, 100);
    });

    scrollToIndex();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-spcc-section]').forEach(initSpccCarousel);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('[data-spcc-section]');
    if (!sectionEl) return;
    sectionEl.removeAttribute('data-spcc-initialized');
    initSpccCarousel(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tele-size-guide"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Kids size recommendation ─────────────────────────── */
  function recommendKids(h) {
    /* True supplier boundaries, converted from cm. DO NOT round to whole inches.
       95cm=37.4  105cm=41.3  115cm=45.3  125cm=49.2  135cm=53.1  145cm=57.1
       At a shared supplier boundary the LARGER size wins. */
    if (h < 37.4)  return { type: 'too_small' };
    if (h < 41.3)  return { type: 'match', size: '4T / 100' };
    if (h < 45.3)  return { type: 'match', size: '6T / 110' };
    if (h < 49.2)  return { type: 'match', size: '8T / 120' };
    if (h < 53.1)  return { type: 'match', size: '10T / 130' };
    if (h <= 57.1) return { type: 'match', size: '12T / 140' };
    return { type: 'too_tall' };
  }

  /* ── Build result HTML ────────────────────────────────── */
  function buildKidsResult(rec) {
    if (rec.type === 'match') {
      return (
        '<div class="tele-sg-result tele-sg-result--match">' +
        '<p class="tele-sg-result__label">RECOMMENDED STARTING SIZE</p>' +
        '<p class="tele-sg-result__size">' + rec.size + '</p>' +
        '<p class="tele-sg-result__body">Based on the height you entered, Kids ' + rec.size + ' is our recommended starting size.</p>' +
        '<p class="tele-sg-result__body">If you&rsquo;re between sizes, choose the larger size.</p>' +
        '<button type="button" class="tele-sg-result__close" data-tele-sg-close-result>GOT IT</button>' +
        '</div>'
      );
    }
    if (rec.type === 'too_small') {
      return (
        '<div class="tele-sg-result tele-sg-result--none">' +
        '<p class="tele-sg-result__label">BELOW KIDS RANGE</p>' +
        '<p class="tele-sg-result__body">The entered height is below our smallest kids size (4T / 100, 37.4–41.3 in). Please double-check the measurement.</p>' +
        '<button type="button" class="tele-sg-result__close" data-tele-sg-close-result>GOT IT</button>' +
        '</div>'
      );
    }
    return (
      '<div class="tele-sg-result tele-sg-result--none">' +
      '<p class="tele-sg-result__label">ABOVE KIDS RANGE</p>' +
      '<p class="tele-sg-result__body">The entered height is above our largest kids size (12T / 140, 53.1–57.1 in). An adult size may be a better fit.</p>' +
      '<button type="button" class="tele-sg-result__close" data-tele-sg-close-result>GOT IT</button>' +
      '</div>'
    );
  }

  /* ── Validate height input ────────────────────────────── */
  function validate(raw) {
    if (raw === '' || raw == null) {
      return { ok: false, msg: 'Please enter a height in inches.' };
    }
    var val = parseFloat(raw);
    if (isNaN(val)) {
      return { ok: false, msg: 'Please enter a number. Example: 46' };
    }
    if (val <= 0) {
      return { ok: false, msg: 'Please enter a positive measurement.' };
    }
    if (val > 100) {
      return { ok: false, msg: 'That measurement seems too large. Please check and try again.' };
    }
    return { ok: true, val: val };
  }

  /* ── Modal state ──────────────────────────────────────── */
  var currentModal = null;
  var lastTrigger  = null;

  function openModal(modal) {
    modal.removeAttribute('hidden');
    modal.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    currentModal = modal;
    var closeBtn = modal.querySelector('[data-tele-sg-close]');
    if (closeBtn) { setTimeout(function () { closeBtn.focus(); }, 50); }
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
    currentModal = null;
    if (lastTrigger) { lastTrigger.focus(); }
  }

  /* ── Focus trap ───────────────────────────────────────── */
  function trapFocus(modal, e) {
    var sel = 'button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])';
    var nodes = Array.prototype.slice.call(modal.querySelectorAll(sel));
    if (!nodes.length) return;
    var first = nodes[0];
    var last  = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }

  /* ── Run calculator ───────────────────────────────────── */
  function runCalc(inputEl, resultEl) {
    var v = validate(inputEl.value.trim());
    if (!v.ok) {
      resultEl.innerHTML = '<p class="tele-sg-result__error">' + v.msg + '</p>';
      resultEl.removeAttribute('hidden');
      return;
    }
    var rec = recommendKids(v.val);
    resultEl.innerHTML = buildKidsResult(rec);
    resultEl.removeAttribute('hidden');

    resultEl.querySelectorAll('[data-tele-sg-close-result]').forEach(function (btn) {
      btn.addEventListener('click', function () { closeModal(currentModal); });
    });
  }

  /* ── Tab switching ────────────────────────────────────── */
  function switchTab(modal, targetId) {
    var tabs   = modal.querySelectorAll('[data-tele-sg-tab]');
    var panels = modal.querySelectorAll('.tele-sg-panel-body');

    tabs.forEach(function (t) {
      var isActive = t.getAttribute('data-tele-sg-tab') === targetId;
      t.classList.toggle('tele-sg-tab--active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach(function (p) {
      var isActive = p.id === 'tele-panel-' + targetId;
      p.classList.toggle('tele-sg-panel-body--active', isActive);
      if (isActive) {
        p.removeAttribute('hidden');
      } else {
        p.setAttribute('hidden', '');
      }
    });
  }

  /* ── Bind trigger buttons ─────────────────────────────── */
  function bindTriggers(modal) {
    document.querySelectorAll('[data-tele-size-trigger]').forEach(function (btn) {
      if (btn._telesgBound) return;
      btn._telesgBound = true;
      btn.addEventListener('click', function () {
        lastTrigger = btn;
        openModal(modal);
      });
    });
  }

  /* ── Init one guide section ───────────────────────────── */
  function initGuide(section) {
    if (section._telesgInit) return;
    section._telesgInit = true;

    var modal = section.querySelector('.tele-sg-modal');
    if (!modal) return;

    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    var backdrop = modal.querySelector('[data-tele-sg-backdrop]');
    if (backdrop) {
      backdrop.addEventListener('click', function () { closeModal(modal); });
    }

    var closeBtn = modal.querySelector('[data-tele-sg-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () { closeModal(modal); });
    }

    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeModal(modal); }
      if (e.key === 'Tab')    { trapFocus(modal, e); }
    });

    var tabs = modal.querySelectorAll('[data-tele-sg-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        switchTab(modal, tab.getAttribute('data-tele-sg-tab'));
      });
    });

    var inputEl  = modal.querySelector('[data-tele-sg-input]');
    var submitEl = modal.querySelector('[data-tele-sg-submit]');
    var resultEl = modal.querySelector('[data-tele-sg-result]');

    if (inputEl && submitEl && resultEl) {
      submitEl.addEventListener('click', function () { runCalc(inputEl, resultEl); });
      inputEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); runCalc(inputEl, resultEl); }
      });
    }

    bindTriggers(modal);
  }

  /* ── Global Escape ────────────────────────────────────── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && currentModal) { closeModal(currentModal); }
  });

  /* ── Init on load ─────────────────────────────────────── */
  function initAll() {
    document.querySelectorAll('.tele-sg-section').forEach(initGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* ── Theme editor section reload ──────────────────────── */
  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;

    var guideSec = container.querySelector('.tele-sg-section');
    if (guideSec) {
      guideSec._telesgInit = false;
      initGuide(guideSec);
      return;
    }

    var existingModal = document.querySelector('.tele-sg-modal');
    if (existingModal) {
      document.querySelectorAll('[data-tele-size-trigger]').forEach(function (btn) {
        btn._telesgBound = false;
      });
      bindTriggers(existingModal);
    }
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teletubbies-onesie-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTeleFaq(section) {
    section.querySelectorAll('.tele-faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.tele-faq-item');
        var isOpen = item.classList.contains('is-open');
        item.closest('.tele-faq-list').querySelectorAll('.tele-faq-item.is-open').forEach(function (openItem) {
          openItem.classList.remove('is-open');
          openItem.querySelector('.tele-faq-q').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.teletubbies-onesie-faq').forEach(initTeleFaq);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('.teletubbies-onesie-faq');
    if (sectionEl) initTeleFaq(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teletubbies-onesie-reaction-quote"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTeleQuoteCarousel(section) {
    if (section.dataset.teleQuoteInitialized) return;
    section.dataset.teleQuoteInitialized = '1';

    var track   = section.querySelector('[data-tele-quote-track]');
    var cards   = section.querySelectorAll('[data-tele-quote-card]');
    var prevBtn = section.querySelector('[data-tele-quote-prev]');
    var nextBtn = section.querySelector('[data-tele-quote-next]');
    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var currentIndex = 0;
    var scrollTimer;
    var resizeTimer;

    function getVisible() {
      return window.innerWidth >= 750 ? 2 : 1;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function updateButtons() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function scrollToIndex() {
      var card = cards[currentIndex];
      if (!card) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - track.offsetLeft) - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      }
      currentIndex = Math.min(closest, getMaxIndex());
      updateButtons();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; scrollToIndex(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) { currentIndex++; scrollToIndex(); }
    });

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        scrollToIndex();
      }, 100);
    });

    scrollToIndex();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-tele-quote-section]').forEach(initTeleQuoteCarousel);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('[data-tele-quote-section]');
    if (!sectionEl) return;
    sectionEl.removeAttribute('data-tele-quote-initialized');
    initTeleQuoteCarousel(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teletubbies-onesie-social-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTeleCarousel(section) {
    if (section.dataset.teleInitialized) return;
    section.dataset.teleInitialized = '1';

    var track   = section.querySelector('[data-tele-track]');
    var cards   = section.querySelectorAll('[data-tele-card]');
    var prevBtn = section.querySelector('[data-tele-prev]');
    var nextBtn = section.querySelector('[data-tele-next]');
    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var currentIndex = 0;
    var scrollTimer;
    var resizeTimer;

    function getVisible() {
      if (window.innerWidth >= 990) return 3;
      if (window.innerWidth >= 750) return 2;
      return 1;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function updateButtons() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function scrollToIndex() {
      var card = cards[currentIndex];
      if (!card) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - track.offsetLeft) - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      }
      currentIndex = Math.min(closest, getMaxIndex());
      updateButtons();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; scrollToIndex(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) { currentIndex++; scrollToIndex(); }
    });

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        scrollToIndex();
      }, 100);
    });

    scrollToIndex();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-tele-section]').forEach(initTeleCarousel);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('[data-tele-section]');
    if (!sectionEl) return;
    sectionEl.removeAttribute('data-tele-initialized');
    initTeleCarousel(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vampire-cloak-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initVcFaq(section) {
    var buttons = section.querySelectorAll('.vc-faq-q');
    var list = section.querySelector('.vc-faq-list');
    if (!buttons.length || !list) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.vc-faq-item');
        if (!item) return;
        var wasOpen = item.classList.contains('is-open');
        list.querySelectorAll('.vc-faq-item.is-open').forEach(function (openItem) {
          openItem.classList.remove('is-open');
          var openBtn = openItem.querySelector('.vc-faq-q');
          if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.vampire-cloak-faq').forEach(initVcFaq);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (evt) {
    var el = evt.target.querySelector('.vampire-cloak-faq');
    if (el) initVcFaq(el);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vampire-cloak-reaction-quote"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initVcQuoteCarousel(section) {
    if (section.dataset.gcQuoteInitialized) return;
    section.dataset.gcQuoteInitialized = '1';

    var track   = section.querySelector('[data-vc-quote-track]');
    var cards   = section.querySelectorAll('[data-vc-quote-card]');
    var prevBtn = section.querySelector('[data-vc-quote-prev]');
    var nextBtn = section.querySelector('[data-vc-quote-next]');
    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var currentIndex = 0;
    var scrollTimer;
    var resizeTimer;

    function getVisible() {
      return window.innerWidth >= 750 ? 2 : 1;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function updateButtons() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function scrollToIndex() {
      var card = cards[currentIndex];
      if (!card) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - track.offsetLeft) - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      }
      currentIndex = Math.min(closest, getMaxIndex());
      updateButtons();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; scrollToIndex(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) { currentIndex++; scrollToIndex(); }
    });

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        scrollToIndex();
      }, 100);
    });

    scrollToIndex();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-vc-quote-section]').forEach(initVcQuoteCarousel);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('[data-vc-quote-section]');
    if (!sectionEl) return;
    sectionEl.removeAttribute('data-vc-quote-initialized');
    initVcQuoteCarousel(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vampire-cloak-social-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initVcCarousel(section) {
    if (section.dataset.gcInitialized) return;
    section.dataset.gcInitialized = '1';

    var track   = section.querySelector('[data-vc-track]');
    var cards   = section.querySelectorAll('[data-vc-card]');
    var prevBtn = section.querySelector('[data-vc-prev]');
    var nextBtn = section.querySelector('[data-vc-next]');
    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var currentIndex = 0;
    var scrollTimer;
    var resizeTimer;

    function getVisible() {
      if (window.innerWidth >= 990) return 3;
      if (window.innerWidth >= 750) return 2;
      return 1;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function updateButtons() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function scrollToIndex() {
      var card = cards[currentIndex];
      if (!card) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - track.offsetLeft) - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      }
      currentIndex = Math.min(closest, getMaxIndex());
      updateButtons();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; scrollToIndex(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) { currentIndex++; scrollToIndex(); }
    });

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        scrollToIndex();
      }, 100);
    });

    scrollToIndex();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-vc-section]').forEach(initVcCarousel);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('[data-vc-section]');
    if (!sectionEl) return;
    sectionEl.removeAttribute('data-vc-initialized');
    initVcCarousel(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weenie-dog-costume-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initWdcFaq(section) {
    var buttons = section.querySelectorAll('.wdc-faq-q');
    var list = section.querySelector('.wdc-faq-list');
    if (!buttons.length || !list) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.wdc-faq-item');
        if (!item) return;
        var wasOpen = item.classList.contains('is-open');
        list.querySelectorAll('.wdc-faq-item.is-open').forEach(function (openItem) {
          openItem.classList.remove('is-open');
          var openBtn = openItem.querySelector('.wdc-faq-q');
          if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.weenie-dog-costume-faq').forEach(initWdcFaq);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (evt) {
    var el = evt.target.querySelector('.weenie-dog-costume-faq');
    if (el) initWdcFaq(el);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weenie-dog-costume-reaction-quote"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initWdcQuoteCarousel(section) {
    if (section.dataset.gcQuoteInitialized) return;
    section.dataset.gcQuoteInitialized = '1';

    var track   = section.querySelector('[data-wdc-quote-track]');
    var cards   = section.querySelectorAll('[data-wdc-quote-card]');
    var prevBtn = section.querySelector('[data-wdc-quote-prev]');
    var nextBtn = section.querySelector('[data-wdc-quote-next]');
    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var currentIndex = 0;
    var scrollTimer;
    var resizeTimer;

    function getVisible() {
      return window.innerWidth >= 750 ? 2 : 1;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function updateButtons() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function scrollToIndex() {
      var card = cards[currentIndex];
      if (!card) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - track.offsetLeft) - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      }
      currentIndex = Math.min(closest, getMaxIndex());
      updateButtons();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; scrollToIndex(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) { currentIndex++; scrollToIndex(); }
    });

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        scrollToIndex();
      }, 100);
    });

    scrollToIndex();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-wdc-quote-section]').forEach(initWdcQuoteCarousel);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('[data-wdc-quote-section]');
    if (!sectionEl) return;
    sectionEl.removeAttribute('data-wdc-quote-initialized');
    initWdcQuoteCarousel(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weenie-dog-costume-social-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initWdcCarousel(section) {
    if (section.dataset.wdcInitialized) return;
    section.dataset.wdcInitialized = '1';

    var track   = section.querySelector('[data-wdc-track]');
    var cards   = section.querySelectorAll('[data-wdc-card]');
    var prevBtn = section.querySelector('[data-wdc-prev]');
    var nextBtn = section.querySelector('[data-wdc-next]');
    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var currentIndex = 0;
    var scrollTimer;
    var resizeTimer;

    function getVisible() {
      if (window.innerWidth >= 990) return 3;
      if (window.innerWidth >= 750) return 2;
      return 1;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function updateButtons() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= getMaxIndex();
    }

    function scrollToIndex() {
      var card = cards[currentIndex];
      if (!card) return;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: card.offsetLeft - track.offsetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - track.offsetLeft) - scrollLeft);
        if (dist < minDist) { minDist = dist; closest = i; }
      }
      currentIndex = Math.min(closest, getMaxIndex());
      updateButtons();
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; scrollToIndex(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) { currentIndex++; scrollToIndex(); }
    });

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        scrollToIndex();
      }, 100);
    });

    scrollToIndex();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-wdc-section]').forEach(initWdcCarousel);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var detail = e.detail;
    var id = detail && detail.sectionId;
    if (!id) return;
    var container = document.getElementById('shopify-section-' + id);
    if (!container) return;
    var sectionEl = container.querySelector('[data-wdc-section]');
    if (!sectionEl) return;
    sectionEl.removeAttribute('data-wdc-initialized');
    initWdcCarousel(sectionEl);
  });
}());

  } catch(e) { console.error(e); }
})();
})();
